// extracted by mini-css-extract-plugin
export default {"NavItem":"Navbar_NavItem__7ryLh"};